module.exports = __webpack_public_path__ + "assets/search-a66e84.svg";